// extracted by mini-css-extract-plugin
module.exports = {"label":"FeatureNameInput_label__wYGgB","inputs-container":"FeatureNameInput_inputs-container__BZkLQ"};